import {IColumnItem} from "@ui/tableCustom/types/columns";
import {Worksheet} from "exceljs";
import {GenerateExportExcelHeadColumnStylesCb} from "@ui/tableCustom/types/table";
import {buildStylesExcelJs} from "@containers/export/containers/excel/exportExcelJs/styles/buildStylesExcelJs";
import {fillEmptyCells, fillEmptyCellsMatrix} from "../mergeCells/fillEmptyCells/fillEmptyCells";
import {setHeaderRowHeight} from "./helpers/setHeaderRowHeight";
import {mergeHeaderCellsByColSpan, mergeHeaderCellsByRowSpan} from "./helpers/mergeCells";


const buildColumns = <T>({
                          worksheet,
                          columns,
                          generateExportExcelHeadColumnStylesCb,
                          rowIndex,
                          dataSetRowIndex,
                      }: {
    worksheet: Worksheet, columns: IColumnItem<T>[],
    rowIndex: number,
    dataSetRowIndex: number,
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb
}) => {
    if (!columns?.length) {
        return
    }
    const columnHeaders = columns.filter((column) => column.hideExport !== true)?.map(column => {
        return column['formulaValue'] ? {formula: column['formulaValue']} : column['title']
    });
    const rowExcelJs = worksheet.addRow(columnHeaders);

    columns.forEach((column, colIndex) => {
        const columnNumber = colIndex + 1
        const cell = rowExcelJs.getCell(columnNumber);

        if (column.colSpan > 1) {
            mergeHeaderCellsByColSpan({
                worksheet,
                dataSetRowIndex,
                rowIndex,
                colIndex,
                colSpan: column.colSpan
            })
        }

        if (column.exportStylesHeader?.excel?.rowHeight) {
            setHeaderRowHeight(rowExcelJs, column.exportStylesHeader?.excel?.rowHeight)
        }

        const exportStyles = generateExportExcelHeadColumnStylesCb ? generateExportExcelHeadColumnStylesCb({column}) : column?.exportStylesHeader?.excel;

        if (exportStyles) {
            buildStylesExcelJs({
                cell,
                exportStyles,
            })
        }
    })

    return rowExcelJs
}

const mergeColumns = <T>({
                          worksheet,
                          columns,
                          rowIndex,
                          dataSetRowIndex,
                      }: {
    worksheet: Worksheet, columns: IColumnItem<T>[],
    rowIndex: number,
    dataSetRowIndex: number,
}) => {
    const rowExcelJs = worksheet.getRow(dataSetRowIndex + rowIndex + 1);

    columns.forEach((column, colIndex) => {
        if (!column.rowSpan || column.rowSpan < 2) {
            return
        }
        const cell = rowExcelJs.getCell(colIndex + 1);

        mergeHeaderCellsByRowSpan({
            dataSetRowIndex,
            rowSpan: column.rowSpan,
            colIndex,
            rowIndex,
            worksheet,
            cell,
        })


    })

}

const buildMatrixColumns = <T>({
                                worksheet,
                                columns,
                                generateExportExcelHeadColumnStylesCb,
                                dataSetRowIndex,
                            }: {
    worksheet: Worksheet,
    columns: IColumnItem<T>[][],
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb,
    dataSetRowIndex: number,
}) => {
    const columnsWidthEmpty = fillEmptyCellsMatrix(columns)

    columnsWidthEmpty.forEach((columns, rowIndex) => {
        buildColumns({
            columns,
            worksheet,
            generateExportExcelHeadColumnStylesCb,
            rowIndex,
            dataSetRowIndex,
        })
    })


    columnsWidthEmpty.forEach((columns, rowIndex) => {
        mergeColumns({
            columns,
            worksheet,
            rowIndex,
            dataSetRowIndex,
        })
    })
}

export const buildHeaderColumns = <T>({
                                       worksheet,
                                       columns,
                                       headColumns,
                                       generateExportExcelHeadColumnStylesCb,
                                       dataSetRowIndex,
                                   }: {
    columns: IColumnItem<T>[];
    headColumns?: IColumnItem<T>[] | IColumnItem<T>[][]
    worksheet: Worksheet,
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb,
    dataSetRowIndex: number,
}) => {

    const currentColumns = headColumns?.length >= 1 ? headColumns : columns;
    if (Array.isArray(currentColumns[0])) {
        buildMatrixColumns({
            columns: currentColumns as IColumnItem<T>[][],
            generateExportExcelHeadColumnStylesCb,
            worksheet,
            dataSetRowIndex,
        })
        return
    }
    const columnsWidthEmpty = fillEmptyCells(currentColumns as IColumnItem<T>[])
    buildColumns({
        columns: columnsWidthEmpty,
        worksheet,
        generateExportExcelHeadColumnStylesCb,
        dataSetRowIndex,
        rowIndex: 0
    })
}